import type { Routes } from '@angular/router';

import { authGuard, guestGuard } from '@core/auth/auth-guard';
import { permissionsResolver } from '@core/auth/permissions-sync';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('@layouts/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: 'login',
        title: 'Sign in',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('@features/auth/login-page/login-page').then((m) => m.LoginPage),
      },
      { path: '', pathMatch: 'full', redirectTo: 'login' },
    ],
  },
  {
    path: '',
    loadComponent: () => import('@layouts/main-layout/main-layout').then((m) => m.MainLayout),
    canActivate: [authGuard],
    // After the guard, so it only runs signed in. Fetched each time the layout opens.
    resolve: { permissions: permissionsResolver },
    children: [
      {
        path: 'businesses',
        title: 'Businesses',
        loadComponent: () =>
          import('@features/businesses/businesses-page/businesses-page').then(
            (m) => m.BusinessesPage,
          ),
      },
      { path: 'category', loadChildren: () => import('@features/category/category.routes') },
      {
        path: 'product-category',
        loadChildren: () => import('@features/category/product-category.routes'),
      },
      {
        path: 'products-services',
        loadChildren: () => import('@features/products-services/products-services.routes'),
      },
      {
        path: 'content-moderation',
        loadChildren: () => import('@features/content-moderation/content-moderation.routes'),
      },
      {
        path: 'user-management',
        loadChildren: () => import('@features/user-management/user-management.routes'),
      },
      {
        path: 'subscriptions',
        loadChildren: () => import('@features/subscriptions/subscriptions.routes'),
      },
      { path: 'settings', loadChildren: () => import('@features/settings/settings.routes') },
      { path: '', pathMatch: 'full', redirectTo: 'category' },
    ],
  },
];
